export default __webpack_public_path__ + "static/media/unknown.acdec28f.svg";